import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=69084ba4&scoped=true"
import script from "./PromotionForm.vue?vue&type=script&lang=js"
export * from "./PromotionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69084ba4",
  null
  
)

export default component.exports